module.exports = __webpack_public_path__ + "img/slideshow_7.a4413219.jpg";